import classNames from 'classnames';
import React from 'react';
import { useContactInitialsFromName } from '@tokenized/sdk-react-private';
import Image from '#components/Elements/Image/Image';
import styles from './EntityIcon.scss';

/**
 * Component renders an avatar image
 */
function EntityIcon({
  src,
  initials,
  displayName,
  className,
  size = 'medium',
  inverted,
  isFaint,
}) {
  const initialsFromName = useContactInitialsFromName(displayName);
  if (initials === undefined) {
    initials = initialsFromName;
  }
  if (initials?.length > 3) {
    initials = initials.slice(0, 3);
  }

  return (
    <Image
      src={src}
      size={size}
      className={classNames(
        className,
        styles.entityIcon,
        inverted && styles.inverted,
        isFaint && styles.faint,
      )}
    >
      <div className={styles.fallback}>
        {initials || <i className={classNames('icomoon', 'icon-user')} />}
      </div>
    </Image>
  );
}

export default EntityIcon;
